import { createContext } from 'react';

import type {
  Nullable,
  PageContextInterface,
} from '@app/providers/PageProvider/PageProvider.types';

export const PageContext = createContext<Nullable<PageContextInterface>>(null);
